var map = {
	"./assisted_onboarding_from_RM.svg": 67221,
	"./create_new_customer.svg": 54140,
	"./data_renewal.svg": 58831,
	"./logoipsum.svg": 56893,
	"./query_audit.svg": 47302,
	"./report_suspicious_indicators.svg": 73647,
	"./search_customer.svg": 33449,
	"./service_default_icon.svg": 83467,
	"./terminate_customer.svg": 12546,
	"./view_renewal_history.svg": 73577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91980;